import React, { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import ConfirmationDialog from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/ConfirmationDialog';
import { getAppEnabled, getCanUseApp } from '../../../../Resources/Organization/Apps/AppsData.js';
import { toggleEnabledWithEntity } from '../Redux/Actions.js';
import { SCHEDULE_ENGINE } from '../AppsData.js';
import ActionToggle from '../ActionToggle';

const ScheduleEngineButton = () => {
  const appEnabled = useSelector(getAppEnabled(SCHEDULE_ENGINE));
  const canUseApp = useSelector(getCanUseApp(SCHEDULE_ENGINE));
  const buttonColor = useSelector((state) => state.buttonColor);
  const buttonText = useSelector((state) => state.buttonText.toUpperCase());
  const [enableDialogOpen, setEnableDialogOpen] = useState(false);
  const [disableDialogOpen, setDisableDialogOpen] = useState(false);
  const dispatch = useDispatch();

  if (!canUseApp) {
    return <Typography>Available only to Superpros</Typography>;
  }

  const onCloseEnableDialog = useCallback(() => setEnableDialogOpen(false), []);
  const onCloseDisableDialog = useCallback(() => {
    window.location = '/pro/apps';
  }, []);
  const toggleAppEnabled = () => dispatch(toggleEnabledWithEntity(SCHEDULE_ENGINE));
  const onSwitchChange = (event, checked) => {
    if (checked) {
      setEnableDialogOpen(true);
      return Promise.resolve(true);
    }

    return toggleAppEnabled().then(() => {
      setDisableDialogOpen(true);
      return Promise.resolve(true);
    });
  };

  const onSignUpClick = useCallback(() => {
    setEnableDialogOpen(false);
    toggleAppEnabled();
    window.open('https://www.scheduleengine.com/housecall-pro?&utm_source=hcp&utm_medium=proportal&utm_campaign=liveservices', '_blank');
  }, []);

  const onLoginClick = useCallback(() => {
    setEnableDialogOpen(false);
    toggleAppEnabled();
    window.open('https://dashboard.scheduleengine.net/', '_blank');
  }, []);

  if (!appEnabled) {
    return <Typography>No longer available</Typography>;
  }

  return (
    <>
      <ActionToggle
        enabled={appEnabled}
        hideToggle={false}
        onClick={onSwitchChange}
        buttonColor={buttonColor}
        buttonText={buttonText}
        canUseApp={canUseApp}
      />
      <ConfirmationDialog
        open={enableDialogOpen}
        title="Connect to Schedule Engine"
        onClose={onCloseEnableDialog}
        leftButton={<Button onClick={onCloseEnableDialog}>Cancel</Button>}
        rightButton={(
          <Button color="primary" onClick={onLoginClick}>
            Connect account
          </Button>
        )}
      >
        <Typography paragraph>
          You’re almost done. Connect with your Implementation Specialist at Schedule Engine to complete setup
        </Typography>

        <Typography paragraph>
          New to Schedule Engine?
          {' '}
          <a href="#" onClick={onSignUpClick} role="button">Sign up today</a>
          .
        </Typography>
      </ConfirmationDialog>

      <ConfirmationDialog
        open={disableDialogOpen}
        title="Schedule Engine"
        onClose={onCloseDisableDialog}
        rightButton={<Button onClick={onCloseDisableDialog}>Cancel</Button>}
      >
        <Typography paragraph>
          You have now disabled Schedule Engine. To turn it back on, visit your Schedule Engine account.
        </Typography>
      </ConfirmationDialog>
    </>
  );
};

export default ScheduleEngineButton;
